import React from "react";
import styles from "./accessible.module.css";
import { ReactComponent as AccessibleIcon } from "../../../../../assests/accessible/message-solid.svg";
import { ReactComponent as AccessibleIcon1 } from "../../../../../assests/accessible/cpu.svg";
import { ReactComponent as AccessibleIcon2 } from "../../../../../assests/accessible/lock.svg";
import { useEffect, useRef, useState } from "react";

const AccessibleSection = () => {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.accessible_wrapper}>
      <div className={styles.accessible_container}>
        <div className={styles.circle}>
          <div
            ref={pRef}
            className={`${styles.text} ${isVisible ? styles.show : ""}`}>
            <AccessibleIcon1 className={styles.icon} width={90} height={90} />
            <div className={styles.talk}>
              <h3>Access</h3>
              <p>
                Access global market securely, basing on smart communication
              </p>
            </div>
          </div>
        </div>
        <div className={styles.circle}>
          <div
            ref={pRef}
            className={`${styles.text} ${isVisible ? styles.show : ""}`}>
            <AccessibleIcon className={styles.icon} width={70} height={70} />
            <div className={styles.talk}>
              <h3>Talk</h3>
              <p>
                Talk to us and let us help you grow your dream and your business
              </p>
            </div>
          </div>
        </div>
        <div className={styles.circle}>
          <div
            ref={pRef}
            className={`${styles.text} ${isVisible ? styles.show : ""}`}>
            <AccessibleIcon2 className={styles.icon} width={90} height={90} />
            <div className={styles.talk}>
              <h3>Find</h3>
              <p>
                Find goods, assets, buyers & sellers through BusinessCorners
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessibleSection;
